<template>
  <div class="product-composition">
    <h2
      v-if="withTitle"
      class="c-mb-1 c-md:c-mb-2 c-lg:c-mb-3 text-center c-md:text-left"
    >
      {{ t('ingredients') }}
    </h2>
    <p class="font-bold h6">
      {{ product.legislativeName }}
    </p>
    <div
      v-if="!showFullComposition"
      v-show="!readMore"
      class="product-item__description text-sm-c show"
      v-html="shortComposition"
    />
    <TransitionCollapse
      v-if="!showFullComposition"
      @after-enter="scrollToTopOfProduct"
    >
      <div
        v-show="readMore"
        class="relative z-2 text-sm-c"
      >
        <div v-html="product.composition" />
        <br>
      </div>
    </TransitionCollapse>
    <div
      v-if="!showFullComposition"
      class="product-item-detail__more relative z-2 text-sm-c c-mb-2 c-mr-6 w-100"
      :class="readMore ? 'text-left' : 'text-right'"
    >
      ...
      <a
        href="#"
        class="stretched-link"
        @click="toggleReadMore"
      >
        {{ readMore ? t('read_less') : t('read_more') }}
      </a>
    </div>
    <p
      v-if="showFullComposition"
      class="text-sm-c"
      v-html="product.composition"
    />
    <p
      v-if="product.allergens"
      class="c-pt-4 text-sm-c"
      v-html="product.allergens"
    />
    <p class="text-sm-c">
      EAN: {{ product.ean }}
    </p>
  </div>
</template>

<script setup>
import { striptags } from 'striptags'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import TransitionCollapse from '@/components/general/BaseTransitionCollapse.vue'

const { t } = useI18n()

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  withTitle: {
    type: Boolean,
    default: true,
  },
  showFullComposition: {
    type: Boolean,
    default: false,
  },
})

const readMore = ref(false)
const offsetTop = ref(0)

const shortComposition = computed(() => {
  return striptags(props.product.composition).slice(0, 220)
})

const toggleReadMore = (event) => {
  event.preventDefault()
  readMore.value = !readMore.value
}

const scrollToTopOfProduct = () => {
  offsetTop.value = document.documentElement.scrollTop
  const navbar = document.querySelector('#js-navbar')
  if (navbar) offsetTop.value -= navbar.offsetHeight + 10
  window.scrollTo({ top: offsetTop.value, behavior: 'smooth' })
}
</script>

<style lang="scss">
.product-composition {
  em {
    text-decoration: underline;
  }
}
</style>

<i18n>
  {
    "cs": {
    "ingredients": "Složení",
    "read_less": "číst méně",
    "read_more": "Číst více"
},
    "sk": {
    "ingredients": "Zloženie",
    "read_less": "čítať menej",
    "read_more": "Čítať ďalšie"
},
    "pl": {
    "ingredients": "Skład",
    "read_less": "zobacz mniej",
    "read_more": "Przeczytaj więcej"
},
    "hu": {
    "ingredients": "Összetevők",
    "read_less": "kevesebbet mutat",
    "read_more": "Tovább"
},
    "de": {
    "ingredients": "Zutaten",
    "read_less": "weniger lesen",
    "read_more": "Mehr lesen"
},
    "at": {
    "ingredients": "Zutaten",
    "read_less": "weniger lesen",
    "read_more": "Mehr lesen"
},
    "ro": {
    "ingredients": "Ingrediente",
    "read_less": "mai puțin",
    "read_more": "mai mult"
},
    "fr": {
    "ingredients": "Composition",
    "read_less": "lire moins",
    "read_more": "En savoir plus"
},
    "it": {
    "ingredients": "Ingredienti",
    "read_less": "leggi di meno",
    "read_more": "Leggi di più"
}
  }
</i18n>
